import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CreateOrgModalProvider, Layout } from '@repo/app-components';
import { Outlet, queryClient } from '@repo/app-router';
import { AuthnProvider } from '@repo/auth';
import { AxiosInstance, AxiosInterceptor } from '@repo/http';
import { Toaster } from '@repo/ui-primitives';
import { SidebarProvider } from '@repo/ui-primitives/sidebar';
import { QueryClientProvider } from '@tanstack/react-query';
import { lazy, Suspense } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { GoogleTagManager } from './components/GoogleTagManager';
const TanStackRouterDevtools = process.env.PUBLIC_ENV === 'production' ? ()=>null : /*#__PURE__*/ lazy(()=>import('@tanstack/router-devtools').then((m)=>({
            default: m.TanStackRouterDevtools
        })));
const IntercomChat = /*#__PURE__*/ lazy(()=>import('@mfe/intercom-chat'));
export function RootComponent() {
    return /*#__PURE__*/ _jsx(AxiosInstance, {
        children: /*#__PURE__*/ _jsx(QueryClientProvider, {
            client: queryClient,
            children: /*#__PURE__*/ _jsx(AuthnProvider, {
                children: /*#__PURE__*/ _jsx(AxiosInterceptor, {
                    children: /*#__PURE__*/ _jsx(HelmetProvider, {
                        children: /*#__PURE__*/ _jsxs(GoogleTagManager, {
                            children: [
                                /*#__PURE__*/ _jsx(SidebarProvider, {
                                    children: /*#__PURE__*/ _jsx(CreateOrgModalProvider, {
                                        children: /*#__PURE__*/ _jsxs(Layout, {
                                            children: [
                                                /*#__PURE__*/ _jsx(Toaster, {}),
                                                /*#__PURE__*/ _jsx(Outlet, {})
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Suspense, {
                                    fallback: null,
                                    children: /*#__PURE__*/ _jsx(IntercomChat, {})
                                }),
                                /*#__PURE__*/ _jsx(Suspense, {
                                    fallback: null,
                                    children: /*#__PURE__*/ _jsx(TanStackRouterDevtools, {
                                        position: "bottom-right"
                                    })
                                })
                            ]
                        })
                    })
                })
            })
        })
    });
}
